import { css } from '@emotion/react';
import { transparentize } from 'polished';

export const mediaQueryMobile = () => '@media (max-width: 767px)';
export const mediaQueryTablet = () => '@media (max-width: 1024px)';
export const mediaQueryTabletOrDesktop = () => '@media (min-width: 768px)';
export const fontSize =
  (size) =>
  ({ theme }) =>
    css`
      font-size: ${theme.fontSizes[size]}px;
    `;

export const getColor =
  (color, weight, opacity = 1) =>
  ({ theme }) => {
    const themeColor = theme.colors[color][weight];
    if (opacity === 1) {
      return themeColor;
    }
    return transparentize(1 - opacity, themeColor);
  };

export const color = (color, weight, opacity) => (props) => {
  return css`
    color: ${getColor(color, weight, opacity)(props)};
  `;
};
